// Marketplace purchases feature switch.
//
// While false, creators can still create, publish and manage listings exactly
// as before (publishing still mints the Stripe Product/Price), but nobody can
// BUY: the storefront shows a "Coming soon" badge instead of Buy, the TV
// dashboard says the same, and POST /api/marketplace/checkout answers 503
// { error: 'coming_soon' } so a purchase cannot be started from the API either.
// Nothing in the database changes; the Stripe Connect checkout code is intact.
//
// Flip to true when checkout is ready (client + server read this file).
export const MARKETPLACE_PURCHASES_ENABLED = true;

export const MARKETPLACE_COMING_SOON_MESSAGE =
  "Purchases open soon — we're adding secure checkout.";

/** Shown to a creator right after a listing goes live. */
export const MARKETPLACE_LISTED_MESSAGE =
  "Your item is listed and visible in the marketplace. Sales open soon — we're adding secure checkout, and your listing will be ready to sell the moment it goes live.";

/** Error code returned by the checkout route while purchases are off. */
export const MARKETPLACE_COMING_SOON_CODE = 'coming_soon';

/**
 * Listing limits, shared by the creator form and the server (publish/update).
 * The minimum is Stripe's floor; note the platform's 20% does not cover Stripe's
 * fee below about $1.75, so the owner may want to raise it.
 */
export const MARKETPLACE_MIN_PRICE_CENTS = 50;
export const MARKETPLACE_MAX_PRICE_CENTS = 1_000_000; // $10,000
export const MARKETPLACE_TITLE_MAX = 80;
export const MARKETPLACE_DESCRIPTION_MAX = 2000;
export const MARKETPLACE_KINDS = ['model', 'world', 'prefab', 'texture', 'avatar'] as const;
